(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-service-v1"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initServiceSliderDots() {
    if (typeof jQuery === 'undefined') {
      return;
    }

    var $sliders = jQuery('.js-service-v1');

    $sliders.each(function () {
      var slider = this;
      var $slider = jQuery(slider);

      function isSlickReady() {
        return $slider.hasClass('slick-initialized');
      }

      function getSlideCount() {
        return $slider.find('.slick-slide').not('.slick-cloned').length;
      }

      function getCurrentIndex() {
        var count = getSlideCount();
        var index = parseInt($slider.find('.slick-current').attr('data-slick-index'), 10);

        if (isNaN(index)) {
          index = 0;
        }

        if (count > 0) {
          index = ((index % count) + count) % count;
        }

        return index;
      }

      function buildDots() {
        var count = getSlideCount();

        if (!count) {
          return;
        }

        var $dots = $slider.next('.service-custom-dots');

        if (!$dots.length) {
          $dots = jQuery('<ul class="service-custom-dots"></ul>');
          $slider.after($dots);
        }

        $dots.empty();

        for (var i = 0; i < count; i++) {
          var $li = jQuery('<li></li>');
          var $button = jQuery('<button type="button" aria-label="Go to slide ' + (i + 1) + '"></button>');

          (function (slideIndex) {
            $button.on('click', function () {
              if ($slider.hasClass('slick-initialized')) {
                $slider.slick('slickGoTo', slideIndex);
              }
            });
          })(i);

          $li.append($button);
          $dots.append($li);
        }

        updateDots();
      }

      function updateDots() {
        var currentIndex = getCurrentIndex();
        var $dots = $slider.next('.service-custom-dots');

        if (!$dots.length) {
          return;
        }

        $dots.find('li').removeClass('active');
        $dots.find('li').eq(currentIndex).addClass('active');
      }

      function setupDotsWhenReady() {
        if (!isSlickReady()) {
          setTimeout(setupDotsWhenReady, 300);
          return;
        }

        buildDots();

        if (slider.dataset.serviceDotsEventsAdded !== 'true') {
          slider.dataset.serviceDotsEventsAdded = 'true';

          $slider.on('afterChange', function () {
            updateDots();
          });

          $slider.on('swipe', function () {
            setTimeout(updateDots, 50);
          });
        }
      }

      setupDotsWhenReady();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initServiceSliderDots();

    setTimeout(initServiceSliderDots, 500);
    setTimeout(initServiceSliderDots, 1000);
    setTimeout(initServiceSliderDots, 2000);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initServiceSliderDots, 500);
  });

  window.addEventListener('resize', function () {
    initServiceSliderDots();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
